import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { FlagList } from '../domain/models/FlagList'
import { FlagsDatasource } from '../infra/datasources/FlagsDatasource'

export const flagsDatasourceAdapter: FlagsDatasource = {
  async listFlags() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/feature-flags`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = FlagList.parse(await response.json())
    return json
  },
  async updateAllFlags(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/feature-flags`,
          httpTokenInterceptor({
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = FlagList.parse(await response.json())
    return json
  }
}
